import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Format Bold"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-format-bold',
    templateUrl: './icon-format-bold.component.html',
    styleUrls: ['./icon-format-bold.component.scss'],
    standalone: false
})
export class IconFormatBoldComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
